<template>
  <vetster-modal
    ref="share"
    :header="$t('app.share-with-friends')"
    @close="close"
    @cancel="close"
  >
    <div
      id="share-url"
      :class="
        highlight
          ? 'border-indigo-400 shadow bg-indigo-100'
          : 'border-neutral-300 bg-neutral-100'
      "
      class="
        block
        w-full
        text-center
        px-4
        py-2
        rounded
        border
        text-neutral-700 text-sm
        whitespace-no-wrap
      "
    >
      {{ url }}
    </div>
    <div class="flex items-center justify-between">
      <vetster-button
        variant="white"
        class="mt-4"
        @click="copy"
      >
        {{ buttonText }}
      </vetster-button>
      <div class="flex items-center justify-between mt-4 pt-4">
        <a
          :href="facebookUrl"
          target="_blank"
          rel="nofollow noopener"
          :title="$t('app.share-on-facebook')"
          class="text-2xl text-neutral-400 hover:text-neutral-600 ml-4"
        >
          <fa :icon="['fab', 'facebook']" />
          <span class="sr-only">{{ $t('app.share-on-facebook') }}</span>
        </a>
        <a
          :href="twitterUrl"
          target="_blank"
          rel="noopener"
          :title="$t('app.share-on-twitter')"
          class="text-2xl text-neutral-400 hover:text-neutral-600 ml-8"
        >
          <fa :icon="['fab', 'twitter']" />
          <span class="sr-only">{{ $t('app.share-on-twitter') }}</span>
        </a>
      </div>
    </div>
  </vetster-modal>
</template>

<script>
import VetsterModal from '@/components/VetsterModal';

export default {
  name: 'VetsterShareModal',

  components: { VetsterModal },

  props: {
    open: {
      default: false,
      type: Boolean,
    },
    url: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      buttonText: this.$t('app.copy-link'),
      highlight: false,
    };
  },

  computed: {
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?${new URLSearchParams({
        u: this.url,
        quote: this.$t('app.join-me-on-vetster'),
      }).toString()}`;
    },

    twitterUrl() {
      return `https://twitter.com/intent/tweet?${new URLSearchParams({
        url: this.url,
        text: this.$t('app.join-me-on-vetster'),
      }).toString()}`;
    },
  },

  watch: {
    open(open) {
      if (open) {
        this.$refs.share?.open();
      } else {
        this.$refs.share?.close();
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },

    copy() {
      this.copyInputText(document.getElementById('share-url'));

      this.buttonText = this.$t('app.copied');
      this.highlight = true;

      setTimeout(() => {
        this.$emit('close');
        this.highlight = false;
        this.buttonText = this.$t('app.copy-link');
      }, 2000);
    },

    copyInputText(el) {
      const range = document.createRange();

      range.selectNode(el);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      document.execCommand('copy');

      window.getSelection().removeAllRanges();
    },
  },
};
</script>
